import { Link, useLocation, useNavigate } from "react-router-dom";
import { ASSETS } from "../../data/arccaContent";

export const ArccaNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goToSteps = () => {
    if (location.pathname === "/arcca") {
      document.getElementById("cum-obtii")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/arcca");
      setTimeout(() => document.getElementById("cum-obtii")?.scrollIntoView({ behavior: "smooth" }), 150);
    }
  };

  return (
    <header
      data-testid="arcca-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/arcca" data-testid="nav-arcca-logo-link" className="flex items-center shrink-0">
          <img src={ASSETS.arccaLogo} alt="Arcca Student Housing" data-testid="nav-arcca-logo" className="h-8 md:h-9 w-auto" />
        </Link>

        <div className="flex items-center gap-2.5 sm:gap-5">
          <div className="hidden md:flex items-center gap-3" data-testid="nav-partners">
            <span className="text-[11px] font-medium uppercase tracking-wider text-slate-400">împreună cu</span>
            <img src={ASSETS.brdLogo} alt="BRD" className="h-5 md:h-6 w-auto" />
            <span className="text-slate-300">×</span>
            <img src={ASSETS.isicLogo} alt="ISIC" className="h-6 md:h-7 w-auto" />
          </div>

          <button
            onClick={goToSteps}
            data-testid="nav-cta"
            className="inline-flex items-center rounded-full bg-arcca px-4 sm:px-5 py-2.5 text-[13px] sm:text-sm font-display font-bold text-arccaink hover:bg-arcca-dark hover:text-white transition-colors whitespace-nowrap"
          >
            Cum obții cardul
          </button>
        </div>
      </div>
    </header>
  );
};

const LogoChip = ({ src, alt, cls }) => (
  <span className="inline-flex items-center justify-center rounded-xl bg-white px-4 py-2.5">
    <img src={src} alt={alt} className={cls} />
  </span>
);

export const ArccaFooter = () => (
  <footer className="bg-arccaink text-white/70" data-testid="arcca-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
      <div className="flex flex-col items-center text-center gap-8">
        <div className="flex flex-wrap items-center justify-center gap-4">
          <img src={ASSETS.arccaLogoWhite} alt="Arcca" className="h-9 w-auto" />
          <span className="text-white/30 text-xl">×</span>
          <LogoChip src={ASSETS.brdLogo} alt="BRD" cls="h-6 w-auto" />
          <LogoChip src={ASSETS.isicLogo} alt="ISIC" cls="h-7 w-auto" />
        </div>
        <p className="text-xs uppercase tracking-[0.25em] text-white/40 font-display font-semibold">
          Arcca × BRD × ISIC
        </p>
      </div>
    </div>
  </footer>
);
